import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const RecentlySearchedBlock = (props) => {
    const device = DeviceContext();
    return (React.createElement("div", { className: `Recently-search-block pdt-20 ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "pdlr-15"}` },
        React.createElement("div", { className: "flexJustifySpaceBetween" },
            React.createElement("div", { className: "DMSanN_16_400 txt_secondary-gray lh-140 pdb-9" },
                "Recently Searched (",
                props.stockCount ? props.stockCount : "0",
                ")"),
            React.createElement("div", { onClick: () => props.setEdit((edit) => !edit) },
                React.createElement("i", { className: "edel-icon-edit hand_cursor" }))),
        React.createElement("div", { className: "border-monochrome-grey" }, props.content)));
};
export default RecentlySearchedBlock;
